import Phaser from 'phaser'
import { GameConfig } from './config/game.config'
import { BootScene } from './scenes/BootScene'
import { PreloadScene } from './scenes/PreloadScene'
import { GameScene } from './scenes/GameScene'

const config: Phaser.Types.Core.GameConfig = {
  ...GameConfig,
  scene: [BootScene, PreloadScene, GameScene],
}

const game = new Phaser.Game(config)

export default game
